import {GET_SELECTEDMONTH} from '../Actions/types'

const initialState= { 
    selectedMonth: {First: "", Second: "", Third: "", Fourth: "", Fifth: ""},

}

export default function (state = initialState, action) {

        switch(action.type) {
            case GET_SELECTEDMONTH: 
                return{
                    ...state,
                    selectedMonth: action.payload
                };
                default: 
            return state;

        }
    }



// WEBPACK FOOTER //
// ./src/Reducers/GetSelectedMonthReducer.js